module.exports = __webpack_public_path__ + "img/benefits_on.86e5f54b.svg";